const en = {
    'create_account': 'Create Account',
    'to_register_you_will_need': 'To register you will need:',
    'reg_term_1': 'Valid drivers license (category B)',
    'reg_term_2': 'Mobile phone number',
    'reg_term_3': 'E-mail address',
    'register': 'Register',
    'sign_1': 'I declare that my uploaded ID is genuine',
    'sign_2': 'I agree that pictures and personal data  are visibly stored and displayed in our secured backoffice',
    'cancel': 'Cancel',
    'confirm': 'Confirm',
    'document_verification': 'Document verification',
    'dv_1': 'Take a photo of the drivers license',
    'dv_2': 'Check if all personal data is correct',
    'dv_3': 'Take a selfie',
    'continue': 'Continue',
    'take_a_photo_of_the_front': 'Take a photo of the front',
    'attention': 'Attention',
    'at_1': 'We only accept a photo of the original document',
    'at_2': 'Do not take photographs of copies of documents or images from other devices',
    'take_a_photo': 'Take a photo',
    'camera_text_1': 'Keep the camera parallel to the surface',
    'camera_text_2': 'Press the button to make a photo...',
    'take_a_photo_of_the_back': 'Take a photo of the back',
    'drivers_license': 'Drivers license',
    'selfie': 'Selfie',
    'name': 'Name',
    'surname': 'Surname',
    'country_of_issue': 'Country of issue of the document',
    'drivers_license_number': 'Drivers license number',
    'expiration_date': 'Expiration date',
    'date_of_birth': 'Date of birth',
    'category_b': 'Category B',
    'dl_problem': 'Something wrong with your Drivers license',
    'please_call_us': 'Please call us <a href="tel:0880883434">088 - 088 34 34</a>',
    'close': 'close',
    'is_info_correct': 'Is the information you entered correct?',
    'yes': 'yes',
    'no': 'no',
    'ok': 'ok',
    'not_dutch_dl': 'Because you don’t have a Dutch drivers license we need a copy of an ID as well',
    'choose_the_type_of_your_document': 'Choose the type of your document',
    'passport': 'Passport',
    'id_card': 'ID card',
    'passport_id_card_number': 'Passport / ID card number',
    'zip_code': 'Zip code',
    'house_number': 'House number',
    'number_addition': 'Number addition',
    'street': 'Street',
    'city': 'City',
    'country': 'Country',
    'use_the_same': 'use the same address for invoice',
    'email': 'Email',
    'phone': 'Phone',
    'credentials': 'Credentials',
    'set_24_password': 'Set a 24-hour password and SMS it to me.',
    'sign_your_new_contract': 'Sign your new contract',
    'agree_1': 'I hereby declare that I have read and agree to the Terms and conditions',
    'agree_2': 'I hereby declare that I have read and agree to the House rules',
    'agree_3': 'I hereby declare that I have read and agree to the Customer contract',
    'agree_4': 'I hereby declare that I have read and agree to the Procedure description',
    'agree': 'Agree',
    'welcome': 'Welcome!',
    'rent_a_bus': 'Rent a bus',
    'get_the_app': 'Get the App!',
    'already_account_title': 'You already have an account!',
    'already_account_text': 'Please, download application to continue',
    'download': 'Download',
    'contacts': 'Contacts',
    'the_are_problems_with_your_camera': '',
    'permission_to_camera': 'There is no camera, please continue registration using your mobile phone',
    'home_zip_code': 'Home zip code',
    'home_house_number': 'Home House number',
    'home_street': 'Home street',
    'home_city': 'Home city',
    'invoice_zip_code': 'Invoice Zip code',
    'invoice_house_number': 'Invoice House number',
    'invoice_street': 'Invoice Street',
    'invoice_city': 'Invoice City',
    'you_did_not_provide': 'You did not provide:',
    'home_address': 'Home address',
    'invoice_address': 'Invoice address',
    'error': 'Error',
    'password': 'Password',
    'pas_req_1': 'Minimum 7 characters',
    'pas_req_2': 'Minimum 1 digit and 1 letter',
    'repeat_password': 'Repeat password',
    'pas_error': 'Passwords must match and be complex',
    'photo_auto': 'The photo will be taken automatically, please wait ...',
    'front_of_id_card': 'Front of ID card',
    'document_number': 'Document number',
    'selfie_pic_text': 'Do not take pictures of yourself from other photos or other devices.',
    'make_selfie': 'Take a selfie',
    'already_account': 'You already have an account!',
    'customer_with_email_1': 'Customer with',
    'customer_with_email': 'email address',
    'already_exists': 'already exists..',
    'call_us_2': 'Please, call us or reset password',
    'reset_password': 'Restore password',
    'call_us': 'Call us support',
    'dl_exp_date': 'Drivers license expiration date',
    'no_need': 'No need',
    'recovery_link_message': 'A recovery link has been sent to your email',
}

export default en